import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.pageURL = window.location.href.split("#")[0]
    this.hash = window.location.hash
    this.update()
  }

  update() {
    const hidden = window.scrollY <= 96
    if (this.linkTarget.hidden !== hidden) this.linkTarget.hidden = hidden
  }

  prepareCache() {
    // Turbo also caches native fragment history. Adjacent columns can share a
    // scroll position, so there may be no subsequent scroll event to restore ↑.
    if (window.location.href.split("#")[0] === this.pageURL && window.location.hash !== this.hash) {
      this.hash = window.location.hash
      this.update()
    } else {
      this.reset()
    }
  }

  reset() { this.linkTarget.hidden = true }
  disconnect() { this.reset() }
}
